import React from 'react';
import { FileText, ExternalLink } from 'lucide-react';

interface FileLinksProps {
  files?: Record<string, string>;
}

export function FileLinks({ files }: FileLinksProps) {
  if (!files || Object.keys(files).length === 0) return null;

  return (
    <div className="flex flex-wrap gap-2">
      {Object.entries(files).map(([key, url]) => (
        <a
          key={key}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold uppercase tracking-wider bg-slate-200 dark:bg-slate-800 border border-slate-300 dark:border-slate-700 rounded hover:bg-slate-200 dark:hover:bg-slate-800 hover:text-slate-800 dark:hover:text-slate-200 transition-colors focus:outline-none uppercase tracking-wider"
        >
          <FileText className="w-3 h-3" />
          <span>{key}</span>
          <ExternalLink className="w-3 h-3 ml-0.5 opacity-70" />
        </a>
      ))}
    </div>
  );
}
